import { urlQuery } from 'lib/helpers'
import { createSelector } from 'reselect'
import { getPageData, getPageParams } from 'selectors/page'
import {
  getIsAdmin,
  getUserID,
  isAuthenticated as getIsAuthenticated,
} from 'selectors/user/session'

export const getAlgoliaResults = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.algoliaResults || {}
)
export const getHits = createSelector(
  getAlgoliaResults,
  (algoliaResults): Record<string, any> => algoliaResults.hits || {}
)
export const getHitsTotal = createSelector(getHits, (hits): number => hits.total || 0)
export const getPagination = createSelector(
  getAlgoliaResults,
  (algoliaResults): Record<string, any> => algoliaResults.pagination || {}
)
export const getPaginationCurrent = createSelector(
  [getPagination, getPageParams],
  (pagination, pageParams): number => pagination.current || Number(pageParams.page - 1) || 0
)
export const getPaginationTotal = createSelector(
  getPagination,
  (pagination): number => pagination.total || 0
)
export const getSelectedFacets = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.selectedFacets || {}
)
export const getSort = createSelector(
  getPageParams,
  (pageParams): string => pageParams.sort || 'default'
)
export const getHitsPerPage = createSelector(getHits, (hits): number => hits.perPage || 100)
export const getAlgoliaQuery = createSelector(
  [getSort, getHitsPerPage, getPaginationCurrent],
  (sort, hitsPerPage, page): Record<string, any> => ({
    ...(sort !== 'default'
      ? {
          sort,
        }
      : {}),
    ...(hitsPerPage !== 100
      ? {
          hitsPerPage,
        }
      : {}),
    ...(page !== 0
      ? {
          page: page + 1,
        }
      : {}),
  })
)
export const getUrlStringWithParams = (params: Record<string, any>) =>
  createSelector([getSelectedFacets, getAlgoliaQuery], (selectedFacets, algoliaQuery): string => {
    const { urlPathString, ...restParams } = params
    const queryParams = { ...selectedFacets, ...algoliaQuery, ...restParams }
    const queryString = urlQuery(queryParams)
    return `${urlPathString}${queryString}`
  })
export const getIsUsersCollection = createSelector(
  [getPageParams, getUserID, getIsAuthenticated],
  (params, userId, isAuthenticated): boolean =>
    (isAuthenticated && Number(userId) === Number(params.ownerId || 0)) || false
)
export const getHasValidPermissions = createSelector(
  [getIsUsersCollection, getIsAdmin],
  (isUsersCollection, isAdmin): boolean => isUsersCollection || isAdmin || false
)
